export default __webpack_public_path__ + "static/media/Whack_2_Words_instructions.c8b543c8.png";